"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("./utils");
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _dateFns = require("date-fns");
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
var _sv = _interopRequireDefault(require("../../../../sv.json"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
var Types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var validationName = "datediff";
var DateDiff = function DateDiff(props) {
  var _a, _b;
  var children = props.children,
    _c = props.diffUnit,
    diffUnit = _c === void 0 ? Types.DateDiffUnits.Days : _c,
    fieldAName = props.fieldAName,
    fieldBName = props.fieldBName,
    i18n = props.i18n,
    maxDiff = props.maxDiff,
    minDiff = props.minDiff,
    _d = props.type,
    type = _d === void 0 ? FSTypes.ValidationTypes.Error : _d,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _e = (0, _useFormContext.default)(),
    addFormValidation = _e.addFormValidation,
    formI18n = _e.i18n,
    getFieldLabel = _e.getFieldLabel,
    removeFormValidation = _e.removeFormValidation;
  (0, _react.useEffect)(function () {
    if (minDiff && maxDiff && minDiff > maxDiff) {
      console.error("Min diff (".concat(minDiff, ") is bigger than max diff (").concat(maxDiff, "), which can't be validated."));
    }
  }, [maxDiff, minDiff]);
  var validation = (0, _react.useCallback)(function (formData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var dateA = (0, _utils.getFieldDate)(fieldAName, formData);
    var dateB = (0, _utils.getFieldDate)(fieldBName, formData);
    if (!dateA || !dateB) {
      return [];
    }
    var diffInSec = Math.abs((0, _dateFns.differenceInSeconds)(dateA, dateB));
    var diffInUnit = diffInSec / diffUnit;
    var validationMessages = [];
    var variables = {
      fieldALabel: String(getFieldLabel(fieldAName)),
      fieldBLabel: String(getFieldLabel(fieldBName)),
      fieldAName: fieldAName,
      fieldBName: fieldBName,
      fieldAValue: String((_a = formData[fieldAName]) === null || _a === void 0 ? void 0 : _a.value),
      fieldBValue: String((_b = formData[fieldBName]) === null || _b === void 0 ? void 0 : _b.value),
      maxDiff: String(maxDiff),
      maxUnitLabel: !maxDiff ? "" : (0, _utils.getUnitLabel)(i18n, (_d = (_c = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _c === void 0 ? void 0 : _c.form) === null || _d === void 0 ? void 0 : _d.dateDiff, (_f = (_e = _sv.default === null || _sv.default === void 0 ? void 0 : _sv.default.validation) === null || _e === void 0 ? void 0 : _e.form) === null || _f === void 0 ? void 0 : _f.dateDiff, maxDiff, diffUnit),
      minDiff: String(minDiff),
      minUnitLabel: !minDiff ? "" : (0, _utils.getUnitLabel)(i18n, (_h = (_g = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _g === void 0 ? void 0 : _g.form) === null || _h === void 0 ? void 0 : _h.dateDiff, (_k = (_j = _sv.default === null || _sv.default === void 0 ? void 0 : _sv.default.validation) === null || _j === void 0 ? void 0 : _j.form) === null || _k === void 0 ? void 0 : _k.dateDiff, minDiff, diffUnit),
      diff: String(diffInUnit)
    };
    if (minDiff && diffInUnit < minDiff) {
      var minText = children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.min) || ((_o = (_m = (_l = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _l === void 0 ? void 0 : _l.form) === null || _m === void 0 ? void 0 : _m.dateDiff) === null || _o === void 0 ? void 0 : _o.min) || _sv.default.validation.form.dateDiff.min, variables);
      validationMessages.push({
        fieldName: fieldAName,
        type: type,
        involvedFieldNames: [fieldAName, fieldBName],
        text: minText
      });
      validationMessages.push({
        fieldName: fieldBName,
        type: type,
        involvedFieldNames: [fieldAName, fieldBName],
        text: minText
      });
    }
    if (maxDiff && diffInUnit > maxDiff) {
      var maxText = children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.max) || ((_r = (_q = (_p = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _p === void 0 ? void 0 : _p.form) === null || _q === void 0 ? void 0 : _q.dateDiff) === null || _r === void 0 ? void 0 : _r.max) || _sv.default.validation.form.dateDiff.max, variables);
      validationMessages.push({
        fieldName: fieldAName,
        type: type,
        involvedFieldNames: [fieldAName, fieldBName],
        text: maxText
      });
      validationMessages.push({
        fieldName: fieldBName,
        type: type,
        involvedFieldNames: [fieldAName, fieldBName],
        text: maxText
      });
    }
    return validationMessages;
  }, [children, diffUnit, fieldAName, fieldBName, (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.dateDiff, getFieldLabel, i18n, maxDiff, minDiff, type]);
  (0, _react.useEffect)(function () {
    addFormValidation("".concat(validationName, "_").concat(uuid), [fieldAName, fieldBName], validation, validateOnChange);
    return function () {
      removeFormValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addFormValidation, fieldAName, fieldBName, removeFormValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = DateDiff;
exports.default = _default;